<template>
  <div
    v-if="loading.show"
    class="position-fixed bg-dark-rbg top-0 start-0 end-0 z-1 bottom-0 d-flex justify-content-center align-items-center"
    style="--bs-bg-opacity: 0.5"
  >
    <div class="spinner-border text-primary" style="width: 5rem; height: 5rem" role="status"></div>
  </div>
</template>

<script lang="ts" setup>
import { useLoadingStore } from '@/stores/loading.store';
const loading = useLoadingStore();
</script>
